module.exports = __webpack_public_path__ + "img/Z60_04.2430e76b.jpg";